import React, { useContext } from "react";
import "./menu.css";

import HomeIcon from "@mui/icons-material/Home";
import PsychologyIcon from "@mui/icons-material/Psychology";
import QueuePlayNextIcon from "@mui/icons-material/QueuePlayNext";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import TextsmsIcon from "@mui/icons-material/Textsms";
import { ModeContext } from "../utils/modes-context";

const Menu = () => {
  const { darkMode } = useContext(ModeContext);

  return (
    <div className={darkMode ? "menu" : "menu menu_lightmode"} id="menu">
      <a href="#home">
        <HomeIcon className="icon" sx={{ fontSize: 30 }} />
      </a>
      <a href="#skills">
        <PsychologyIcon className="icon" sx={{ fontSize: 30 }} />
      </a>
      <a href="#resume">
        <AttachFileIcon className="icon" sx={{ fontSize: 30 }} />
      </a>
      <a href="#projects">
        <QueuePlayNextIcon className="icon" sx={{ fontSize: 30 }} />
      </a>
      <a href="#contact">
        <TextsmsIcon className="icon" sx={{ fontSize: 30 }} />
      </a>
    </div>
  );
};

export default Menu;
